import { MuiTelInput } from 'mui-tel-input'
import { TextField } from 'ui/baseComponents/FormFields'
import { SHARED_STYLES } from './consts'
import { colors } from 'theme/colors'

const STYLES = {
  disabled: {
    '&.MuiTelInput-TextField': SHARED_STYLES.disabledInputBox,
    '&.MuiTelInput-TextField > label': {
      backgroundColor: colors.WHITE,
    },
    ...SHARED_STYLES.disabledInput,
  },
  readOnly: SHARED_STYLES.readOnlyInput,
}

const PhoneInput = ({
  disabled,
  disableDropdown = true,
  error,
  helperText,
  label,
  name,
  onChange,
  placeholder,
  readOnly,
  value,
}) => {
  const handleChange = (value) => {
    onChange({
      target: {
        name,
        value,
      },
    })
  }

  return (
    <MuiTelInput
      {...{
        defaultCountry: 'US',
        disabled,
        disableDropdown,
        error,
        fullWidth: true,
        helperText,
        label,
        onChange: handleChange,
        placeholder,
        value,
        inputComponent: TextField,
        sx: {
          ...(disabled && !readOnly && STYLES.disabled),
          ...(readOnly && STYLES.readOnly),
        },
      }}
    />
  )
}

export default PhoneInput
